import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import {ActivityLogSortFields} from 'src/modules/profile/user/tabs/user-activity-log/typedef';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';


export const bulkActionsLogStateSlice = getCachedTableStateSlice<
    undefined,
    ActivityLogSortFields,
    undefined
>('bulkActionLogs', ActivityLogSortFields.START_DATE, {pageSize: 25, currentPage: 1}, SortDirections.DESC);

export const bulkActivityLogsStateActions = bulkActionsLogStateSlice.actions;
export const bulkActivityLogsStateSelector:
CachedTableStateSelector<undefined, ActivityLogSortFields, undefined>
    = state => state.userPage.tabs.userActivityLogs.state;
